import React from "react";
import strings from "../../helpers/Localization";
import TagChip from "./TagChip";
import Modal from "../Modal/Modal";

const ChooseTags = ({ maxWidth, allTags, elementTags, onChangeTags, onOpenModal, onCloseModal }) => {
    const [tagsModalsOpen, setTagsModalsOpen] = React.useState(false);
    const [tagsToAdd, setTagsToAdd] = React.useState([]);
    const [tagsToRemove, setTagsToRemove] = React.useState([]);

    const openModal = () => {
        if (onOpenModal) {onOpenModal();}
        setTagsModalsOpen(true);
    };
    const closeModal = () => {
        if (onCloseModal) {onCloseModal();}
        setTagsModalsOpen(false);
    };

    return <>
        <div className="custom-select-container"
            style={{ maxWidth: maxWidth ? maxWidth + "px" : null, flexGrow: "1", flex: "1", flexShrink: "0", display: "flex",
                alignItems: "center", justifyContent: "flex-start", padding: "0 10px", gap: "10px" }}
        >
            {
                elementTags.map((etag, index) => {
                    return <TagChip
                        key={index}
                        tagName={etag.value}
                        onDelete={() => {
                            onChangeTags(elementTags.filter(t => t.value !== etag.value));
                        }}
                    />;
                })
            }
            <span style={{ display: "flex", flexGrow: "1" }}/>
            <a className="TextContent14" style={{ cursor: "pointer", fontWeight: "500", textDecorationLine: "underline" }}
                onClick={(e) => openModal()}
            >{strings.chooseTag}</a>
        </div>
        <Modal
            open={tagsModalsOpen}
            onClose={() => closeModal()}
            title={strings.chooseTag}
            icon={"dots"}
            onValidate={() => {
                closeModal();
                const newList = tagsToAdd;
                elementTags.forEach(tag => {
                    if (!tagsToRemove.some(t => t.value === tag.value)) {
                        newList.push(tag);
                    }
                });
                onChangeTags(newList);
                setTagsToAdd([]);
                setTagsToRemove([]);
            }}
        >
            <div className={"horizontalFlexContainer"} style={{ flexWrap: "wrap", gap: "10px" }}>
                {
                    (allTags ? allTags : []).map((tag, index) => {
                        const isSelected = (elementTags && elementTags.some(t => t.value === tag.value)
                        || tagsToAdd.some(t => t.value === tag.value)) && !tagsToRemove.some(t => t.value === tag.value);
                        return <TagChip
                            key={index}
                            selected={isSelected}
                            tagName={tag.value}
                            onSelect={() => {
                                if (isSelected) {
                                    if (tagsToAdd.some(t => t.value === tag.value)) {
                                        setTagsToAdd(tagsToAdd.filter(t => t.value !== tag.value));
                                    }
                                    setTagsToRemove([...tagsToRemove, tag]);
                                }
                                else {
                                    if (tagsToRemove.some(t => t.value === tag.value)) {
                                        setTagsToRemove(tagsToRemove.filter(t => t.value !== tag.value));
                                    }
                                    setTagsToAdd([...tagsToAdd, tag]);
                                }
                            }}
                        />;
                    })
                }
            </div>
        </Modal>
    </>;
};

export default ChooseTags;
